import { useEffect } from "react";

import { KeyBy } from "@m7-health/shared-utils";
import { keyBy } from "lodash";

import { useAppConfigQuery } from "#/features/User/queries";
import { IUnit } from "@/api";
import { useDeepMemo } from "@/common/hooks";

import { TAppConfigState, useAppConfigDispatch } from "../../store";

import type { PayloadAction } from "@reduxjs/toolkit";

export type IUnitState = {
  // All units accessible to the user. Generally all units of the facilities the user has access to.
  units: IUnit[];
  unitById: Partial<KeyBy<IUnit, "id">>;
  // Units the user is explicitly assigned to.
  rosterUnits: IUnit[];
  rosterUnitById: Partial<KeyBy<IUnit, "id">>;
};

export const unitInitialState: IUnitState = {
  units: [],
  unitById: {},
  rosterUnits: [],
  rosterUnitById: {},
};

export const unitActions = {
  setUnits: ({ unit: state }: TAppConfigState, { payload }: PayloadAction<{ units: IUnit[] }>) => {
    state.units = payload.units;
    state.unitById = keyBy(payload.units, "id");
  },
  setRosterUnits: (
    { unit: state }: TAppConfigState,
    { payload }: PayloadAction<{ rosterUnits: IUnit[] }>,
  ) => {
    state.rosterUnits = payload.rosterUnits;
    state.rosterUnitById = keyBy(payload.rosterUnits, "id");
  },
};

export const useSynchUnits = () => {
  const dispatch = useAppConfigDispatch();
  const appConfig = useAppConfigQuery();

  const accessibleUnits = useDeepMemo(
    () => appConfig.data?.accessibleUnits,
    [appConfig.data?.accessibleUnits],
  );
  const rosterUnits = useDeepMemo(() => appConfig.data?.units, [appConfig.data?.units]);

  useEffect(() => {
    if (accessibleUnits?.length) dispatch.setUnits({ units: accessibleUnits as IUnit[] });
    if (rosterUnits?.length) dispatch.setRosterUnits({ rosterUnits: rosterUnits as IUnit[] });
  }, [accessibleUnits, rosterUnits, dispatch]);
};
